/**
 * Largeur de la colonne des titres : bornes, pas clavier et persistance navigateur.
 *
 * Chaque accès au `localStorage` est protégé : stockage vide, désactivé ou plein ne doit
 * jamais empêcher le rendu (mode privé, politique d'entreprise, quota).
 */

export const SIDEBAR_DEFAULT = 260;
export const SIDEBAR_MIN = 160;
export const SIDEBAR_MAX = 640;
export const SIDEBAR_KEY_STEP = 16;
export const SIDEBAR_STORAGE_KEY = 'exiplan-gantt-sidebar-width';

/** Borne une largeur (px) dans [SIDEBAR_MIN, SIDEBAR_MAX] ; valeur invalide -> défaut. */
export function clampSidebarWidth(value) {
  if (!Number.isFinite(value)) return SIDEBAR_DEFAULT;
  return Math.min(SIDEBAR_MAX, Math.max(SIDEBAR_MIN, Math.round(value)));
}

/** Largeur retenue, ou défaut si absente, illisible ou stockage indisponible. */
export function readSidebarWidth(storageKey = SIDEBAR_STORAGE_KEY) {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (raw === null) return SIDEBAR_DEFAULT;
    return clampSidebarWidth(Number(raw));
  } catch {
    return SIDEBAR_DEFAULT;
  }
}

/** Retient la largeur ; échec silencieux si le stockage est indisponible. */
export function writeSidebarWidth(width, storageKey = SIDEBAR_STORAGE_KEY) {
  try {
    window.localStorage.setItem(storageKey, String(clampSidebarWidth(width)));
  } catch {
    // Stockage indisponible : la largeur vaut pour la session, sans persistance.
  }
}
